import { createClient } from '@supabase/supabase-js';

// Auth links (recovery / invite) may carry error params in the URL hash; supabase-js clears the hash when it initialises, so keep a copy.
export const authUrlParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.hash.replace(/^#/, '') + '&' + window.location.search.replace(/^\?/, '')) : new URLSearchParams();

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Production safeguard: the live domain must only ever talk to the Production project.
const PRODUCTION_HOST = 'os.alvora.ie';
const PRODUCTION_REF = 'lmvtyigaiqyfqxfmrjkx';
const onProductionHost = typeof window !== 'undefined' && window.location.hostname === PRODUCTION_HOST;
export const environmentMismatch = onProductionHost && !(supabaseUrl || '').includes(PRODUCTION_REF);
if (environmentMismatch) console.error('[Alvora] Refusing to start: production host is configured against a non-production Supabase project.');
export const environmentLabel = onProductionHost ? '' : ((supabaseUrl || '').includes(PRODUCTION_REF) ? '' : 'NON-PRODUCTION (Restore Test)');

export const supabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey) && !environmentMismatch;

export const supabase = supabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
